import { Button, message } from "antd";
import WeaDialog from "../wea-dialog";
import WeaLocaleProvider from "../wea-locale-provider";
import WeaFormItem from "../wea-form-item";
import WeaSelect from "../wea-select";
import WeaInput from "../wea-input";
import WeaHelpfulTip from "../wea-helpful-tip";
import { ls } from "../wea-tools/storage";
import { callApi } from "../wea-tools/callApi";

const getLabel = WeaLocaleProvider.getLabel;

const options = [
  {
    disabled: false,
    key: "4",
    selected: false,
    showname: "公开",
    visible: true
  },
  {
    disabled: false,
    key: "3",
    selected: false,
    showname: "内部",
    visible: true
  },
  {
    disabled: false,
    key: "2",
    selected: false,
    showname: "秘密",
    visible: true
  },
  {
    disabled: false,
    key: "1",
    selected: false,
    showname: "机密",
    visible: true
  }
];
const linkageValue = { 0: "", 1: "20年", 2: "10年", 3: "", 4: "" };
class EditSet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      linkageValue: {},
      secretLevelValidity: "",
      secretLevel: "", // 当前修改的文件密级
      showname: ""
    };
  }
  selectRef = null;
  componentDidMount() {
    const { secLevel } = this.props;
    new Promise(rs => {
      if (!window.hasGetOpenClassification) {
        window.hasGetOpenClassification = true;
        callApi(
          "/api/hrm/classifiedProtection/getClassificationInfo4Component",
          "GET",
          {}
        )
          .then(res => {
            if (res.status) {
              const { isOpenClassification, resourceOptionInfo } = res;
              window.localStorage.setItem(
                "resourceOptionInfo",
                JSON.stringify(resourceOptionInfo)
              );
              window.localStorage.setItem(
                "isOpenClassification",
                isOpenClassification
              );
              window.hasGetOpenClassification = true;
            } else {
              window.hasGetOpenClassification = false;
            }
            rs();
          })
          .catch(err => {
            window.hasGetOpenClassification = false;
          });
      } else {
        rs();
      }
    }).then(() => {
      const lsResourceOptionInfo = ls.getJSONObj("resourceOptionInfo");
      const resourceOptionInfo =
        lsResourceOptionInfo &&
        Array.isArray(lsResourceOptionInfo.resourceOptionList)
          ? lsResourceOptionInfo
          : {
              resourceOptionList: options,
              resourceValidityInfo: linkageValue
            };
      resourceOptionInfo.resourceOptionList = resourceOptionInfo.resourceOptionList.map(
        item => {
          item.disabled = false;
          item.disabled = item.key < secLevel;
          return item;
        }
      );
      this.setState({
        options: resourceOptionInfo.resourceOptionList,
        linkageValue: resourceOptionInfo.resourceValidityInfo,
        secretLevel: secLevel,
        secretLevelValidity: resourceOptionInfo.resourceValidityInfo[secLevel]
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    const { currentFile } = nextProps;
    const { options, linkageValue } = this.state;
    if (!nextProps.isEditSec) {
      // 新上传
      this.setState({
        secretLevel: nextProps.secLevel,
        secretLevelValidity: linkageValue[nextProps.secLevel]
      });
    } else {
      // 修改密级
      this.setState({
        secretLevel: currentFile.secretLevel,
        secretLevelValidity: currentFile.secretLevelValidity
      });
    }
    if (this.props.secLevel !== nextProps.secLevel) {
      // 模块密级修改后
      const newOptions = options.map(item => {
        item.disabled = false;
        item.disabled = item.key < nextProps.secLevel;
        return item;
      });
      this.setState({ options: newOptions }, () => {
        this.selectRef && this.selectRef.forceUpdate();
      });
    }
  }

  onEditSave = () => {
    const { onSave, changeVisible, isEditSec, onEditSec } = this.props;
    const { secretLevel, secretLevelValidity, showname } = this.state;
    if (secretLevel < 3 && !secretLevelValidity) {
      message.error(getLabel(530992, "保密期限不能为空"), 2);
    } else if (secretLevel < 3 && !isNaN(secretLevelValidity)) {
      message.error(getLabel(530063, "保密期限不能为纯数字"), 2);
    } else {
      changeVisible(false);
      if (isEditSec) {
        onEditSec({ secretLevel, secretLevelValidity }, showname);
      } else {
        onSave({ secretLevel, secretLevelValidity });
      }
      this.setState({ showname: "" });
    }
  };

  onEditCancel = () => {
    const { changeVisible, onCancel } = this.props;
    changeVisible(false);
    onCancel();
    this.setState({ showname: "" });
  };

  getBtn = () => {
    const { ecId } = this.props;
    return [
      <Button
        ecId={`${ecId}_Button@dcrpdd`}
        type="primary"
        onClick={this.onEditSave}
      >
        {getLabel(30986, "保存")}
      </Button>,
      <Button ecId={`${ecId}_Button@xi62n1`} onClick={this.onEditCancel}>
        {getLabel(31129, "取消")}
      </Button>
    ];
  };
  onSelectChange = (v, showname) => {
    const { linkageValue } = this.state;
    this.setState({
      secretLevel: v,
      secretLevelValidity: linkageValue[v],
      showname
    });
  };

  onInputChange = v => {
    this.setState({ secretLevelValidity: v });
  };

  render() {
    const { visible, isEditSec, ecId, currentFile } = this.props;
    const { options, secretLevel, secretLevelValidity } = this.state;
    const filename = currentFile.filename || "";
    return (
      <WeaDialog
        ecId={`${ecId}_WeaDialog@z4e0y6`}
        title={
          isEditSec
            ? `${getLabel(528812, "修改密级")}:【${filename}】`
            : getLabel(528813, "请先确认附件密级")
        }
        icon="icon-coms02-Warning"
        iconBgcolor="#ff8e00"
        style={{ width: 600, height: 120 }}
        visible={visible}
        hasScroll={true}
        buttons={this.getBtn()}
        onCancel={this.onEditCancel}
      >
        <WeaFormItem
          ecId={`${ecId}_WeaFormItem@5oiaqg`}
          label={getLabel(500520, "密级")}
          labelCol={{ span: 3, offset: 2 }}
          wrapperCol={{ span: 12, offset: 8 }}
          style={{ padding: "10px" }}
        >
          <WeaSelect
            ref={e => (this.selectRef = e)}
            ecId={`${ecId}_WeaSelect@upfpl7`}
            options={options}
            value={secretLevel}
            onChange={this.onSelectChange}
          />
        </WeaFormItem>
        {secretLevel < 3 && (
          <WeaFormItem
            ecId={`${ecId}_WeaFormItem@3iqkd5`}
            label={getLabel(131188, "保密期限")}
            labelCol={{ span: 3, offset: 2 }}
            wrapperCol={{ span: 12, offset: 8 }}
            viewAttr={3}
            style={{ padding: "10px" }}
          >
            <WeaInput
              ecId={`${ecId}_WeaInput@ado2ug`}
              viewAttr={3}
              value={secretLevelValidity}
              placeholder={getLabel(530018, "请输入保密期限")}
              onChange={this.onInputChange}
            />
            <WeaHelpfulTip
              ecId={`${ecId}_WeaHelpfulTip@tc6qi1`}
              title={getLabel(
                528340,
                "保密期限填写格式：3个月、10年、20年、长期…不能是纯数字"
              )}
              placement="bottom"
              width={200}
              style={{
                position: "absolute",
                right: "-40px",
                top: "7px"
              }}
            />
          </WeaFormItem>
        )}
      </WeaDialog>
    );
  }
}

export default EditSet;



// WEBPACK FOOTER //
// ./ecology9/wea-upload/secLevelDialog.js